/* ==========================================================================
   NOOKISM, swatch grid canvas (atop a graph-paper grid
   scattered with colour squares, a giant wordmark sitting on top). Draws a
   thin grid, a sparse initial scatter of filled cells that pops in staggered
   once the canvas enters view, then keeps painting: moving the cursor over
   an empty cell fills it with a fresh colour, building up a trail as you
   hover. Cheap: the load-in reveal is the only continuous rAF loop; after
   that, drawing only happens on the actual cell-change events (resize,
   hover), not every frame. Static frame (no hover) for reduced motion, the
   Shopify editor, touch, and canvas-unsupported browsers.
   Usage: <canvas data-nk-swatchgrid data-cell="64" data-line="#111110"
                   data-colours="#EC4422,#DFE45C,..." data-density="0.16">
   ========================================================================== */
(function () {
  if (window.__nkSwatchGrid) return;
  window.__nkSwatchGrid = true;

  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var EDITOR = !!(window.Shopify && window.Shopify.designMode);
  var COARSE = window.matchMedia && window.matchMedia('(hover: none)').matches;

  function hexToRgb(hex) {
    hex = (hex || '#111110').replace('#', '');
    if (hex.length === 3) hex = hex.replace(/(.)/g, '$1$1');
    var n = parseInt(hex, 16);
    return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
  }

  function setup(cv) {
    cv.dataset.nkInit = '1';
    var ctx = cv.getContext('2d');
    if (!ctx) return;
    var lineColour = cv.dataset.line || '#111110';
    var colours = (cv.dataset.colours || '#EC4422,#DFE45C').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    var cellBase = parseFloat(cv.dataset.cell) || 64;
    var density = parseFloat(cv.dataset.density) || 0.16;
    var isStatic = cv.hasAttribute('data-static') || REDUCE || EDITOR;

    var W = 0, H = 0, dpr = 1, cell = cellBase, cols = 0, rows = 0;
    var cellsFill = []; // {i,j,c,d}
    var filled = {};    // "i|j" -> true, for O(1) hover lookups
    var t0 = 0, dur = 900, started = false, done = isStatic;

    function key(i, j) { return i + '|' + j; }

    function layout() {
      var r = cv.getBoundingClientRect();
      W = Math.max(1, r.width); H = Math.max(1, r.height);
      dpr = Math.min(2, window.devicePixelRatio || 1);
      cv.width = W * dpr; cv.height = H * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      cell = cellBase;
      cols = Math.ceil(W / cell) + 1;
      rows = Math.ceil(H / cell) + 1;
      seed();
    }

    function seed() {
      cellsFill = []; filled = {};
      var target = Math.round(cols * rows * density);
      var guard = target * 6;
      while (cellsFill.length < target && guard-- > 0) {
        var i = (Math.random() * cols) | 0, j = (Math.random() * rows) | 0;
        var k = key(i, j);
        if (filled[k]) continue;
        filled[k] = true;
        cellsFill.push({ i: i, j: j, c: colours[(Math.random() * colours.length) | 0], d: Math.random(), s: 1 });
      }
    }

    function drawGrid() {
      ctx.strokeStyle = lineColour;
      ctx.globalAlpha = 0.55;
      ctx.lineWidth = 1;
      ctx.beginPath();
      for (var x = 0; x <= cols; x++) { ctx.moveTo(x * cell + 0.5, 0); ctx.lineTo(x * cell + 0.5, H); }
      for (var y = 0; y <= rows; y++) { ctx.moveTo(0, y * cell + 0.5); ctx.lineTo(W, y * cell + 0.5); }
      ctx.stroke();
      ctx.globalAlpha = 1;
    }

    function paintCell(c, s) {
      var pad = cell * 0.08 * (1 - s * 0.4);
      var x = c.i * cell + pad, y = c.j * cell + pad, w = cell - pad * 2, h = cell - pad * 2;
      var cx = x + w / 2, cy = y + h / 2, sw = w * (0.2 + 0.8 * s), sh = h * (0.2 + 0.8 * s);
      ctx.fillStyle = c.c;
      ctx.fillRect(cx - sw / 2, cy - sh / 2, sw, sh);
    }

    // instant, non-animated redraw: used after the initial reveal settles, so
    // hover-painted cells appear immediately (a responsive trail, not a delayed pop)
    function renderNow() {
      ctx.clearRect(0, 0, W, H);
      drawGrid();
      cellsFill.forEach(function (c) { paintCell(c, c.s); });
    }

    function frame(now) {
      if (!started) { started = true; t0 = now; }
      var p = done ? 1 : Math.min(1, (now - t0) / dur);
      ctx.clearRect(0, 0, W, H);
      drawGrid();
      cellsFill.forEach(function (c) {
        var local = Math.max(0, Math.min(1, (p - c.d * 0.7) / 0.3));
        if (local <= 0) return;
        var s = local * local * (3 - 2 * local); // smoothstep pop
        c.s = s;
        paintCell(c, s);
      });
      if (p >= 1) done = true;
      if (!done && !isStatic) raf = requestAnimationFrame(frame);
      else if (done) renderNow(); // land on the instant-draw path once settled
    }

    var raf = 0;
    function play() {
      if (isStatic) { layout(); done = true; renderNow(); return; }
      layout();
      cancelAnimationFrame(raf);
      started = false; done = false;
      raf = requestAnimationFrame(frame);
    }

    // hover-paint: moving the cursor over an empty cell fills it in, building
    // a trail. Only redraws when the hovered CELL changes, not per pixel
    var lastHoverKey = null;
    function onMove(e) {
      if (!done) return; // let the initial reveal finish first
      var r = cv.getBoundingClientRect();
      var x = e.clientX - r.left, y = e.clientY - r.top;
      if (x < 0 || y < 0 || x > r.width || y > r.height) return;
      var i = (x / cell) | 0, j = (y / cell) | 0;
      var k = key(i, j);
      if (k === lastHoverKey) return;
      lastHoverKey = k;
      if (filled[k]) return;
      filled[k] = true;
      cellsFill.push({ i: i, j: j, c: colours[(Math.random() * colours.length) | 0], d: 0, s: 1 });
      renderNow();
    }

    play();
    if (!isStatic && !COARSE) {
      cv.addEventListener('mousemove', onMove);
      cv.addEventListener('mouseleave', function () { lastHoverKey = null; });
    }

    window.addEventListener('resize', function () {
      clearTimeout(cv.__nkRz);
      cv.__nkRz = setTimeout(play, 150);
    }, { passive: true });

    if (!isStatic && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting && !done) play(); });
      }, { threshold: 0.15 }).observe(cv);
    }
  }

  function initAll() {
    document.querySelectorAll('canvas[data-nk-swatchgrid]:not([data-nk-init])').forEach(setup);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  if (window.MutationObserver) {
    new MutationObserver(initAll).observe(document.documentElement, { childList: true, subtree: true });
  }
  document.addEventListener('shopify:section:load', initAll);
})();
